import React, { useCallback } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { SettingsItem } from 'design-system';
import Modal from 'utils/packages/Modal';
import ModalWeb from 'design-system/ModalWeb';
import { rem } from 'design-system/values';
import { isWeb } from '../../../constants';
import { getDisputeMeta } from '../utils/disputeMeta';
// Picker scrolls only when the list exceeds this many rows. Below the
// threshold the modal sizes to its content.
const MAX_VISIBLE_ITEMS = 5;
// Estimated SettingsItem height (icon + topDescription + title). Used only
// to cap the modal when scrolling kicks in — tune if a visible 6th row peeks.
const ITEM_HEIGHT_ESTIMATE = rem(76);
const SCROLLABLE_MAX_HEIGHT = ITEM_HEIGHT_ESTIMATE * MAX_VISIBLE_ITEMS;
const DisputeItemPickerModalContent = ({ items, onSelect, closeModal, }) => {
    const onPress = useCallback((item) => () => {
        closeModal();
        onSelect(item);
    }, [closeModal, onSelect]);
    return (<View style={styles.content}>
      {items.map((item, index) => {
            const meta = getDisputeMeta(item.disputeType, {
                iconUrl: item.iconUrl,
                lenderName: item.lenderName,
            });
            return (<SettingsItem key={`${item.disputeType}-${index}`} title={item.description ?? item.label} topDescription={meta.topLabel} icon={meta.icon} renderIcon={meta.renderIcon} onPress={onPress(item)}/>);
        })}
    </View>);
};
export const DisputeItemPickerModal = {
    show: ({ items, onSelect, onWillClose, onAfterClose }) => {
        const isScrollable = items.length > MAX_VISIBLE_ITEMS;
        if (isWeb) {
            const content = (<DisputeItemPickerModalContent items={items} onSelect={onSelect} closeModal={ModalWeb.hide}/>);
            ModalWeb.show(isScrollable ? (<ScrollView style={styles.webScroll}>{content}</ScrollView>) : (content), {
                containerStyle: styles.modalWeb,
                title: 'Select item to dispute',
                titleBottomBorder: true,
                lightBg: true,
                onDidHideCallback: () => {
                    onWillClose?.();
                    onAfterClose?.();
                },
            });
            return;
        }
        Modal.show(<DisputeItemPickerModalContent items={items} onSelect={onSelect} closeModal={Modal.hide}/>, {
            containerStyle: styles.modal,
            title: 'Select item to dispute',
            onModalWillHide: onWillClose,
            onDidHideCallback: onAfterClose,
            ...(isScrollable && {
                scrollable: { maxHeight: SCROLLABLE_MAX_HEIGHT },
            }),
        });
    },
    hide: () => {
        if (isWeb) {
            ModalWeb.hide();
            return;
        }
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    modalWeb: {
        paddingHorizontal: 8,
        paddingBottom: 0,
    },
    webScroll: {
        maxHeight: SCROLLABLE_MAX_HEIGHT,
    },
    content: {
        paddingBottom: rem(14),
        paddingTop: rem(8),
    },
});
